import React from 'react';
import { useLoaderData } from 'react-router-dom';
import Header from '../Header/Header';
import Quiz from '../Quiz/Quiz';

const Home = () => {
    const quizes = useLoaderData().data;
    return (
        <div>
            <div>
                <Header></Header>

            </div>
            <div>
                <Quiz quizes={quizes}></Quiz>
            </div>


        </div>
    );
};

export default Home;